// extracted by mini-css-extract-plugin
module.exports = {"metricValue":"styles-module--metric-value--3qgLZ","metricName":"styles-module--metric-name--fE4N6"};